export const commonSupportFieldKeysMap = new Map([
    ['country', 'Country'],
    ['language', 'Language'],
    ['city', 'City'],
]);
